import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useQuoteForm = defineStore('quote-form', () => {
    const aaci = ref(null);
    const aacri = ref(null);

    const handleUrlParams = () => {
        const urlParams = new URLSearchParams(window.location.search);

        if (urlParams.has('aaci')) {
            aaci.value = urlParams.get('aaci');
        }

        if (urlParams.has('aacri')) {
            aacri.value = urlParams.get('aacri');
        }
    };

    return {
        aaci,
        aacri,
        handleUrlParams,
    };
});
